import PropTypes from 'prop-types';
import { Grid } from '@ui-propulsion/react-components';
import styles from './helpCenterGrid.module.scss';
import HelpCenterListWrapper from '../helpCenterListWrapper/helpCenterListWrapper';
import HelpCenterListItem from '../helpCenterListItem/helpCenterListItem';

export default function HelpCenterGrid({
  topLeftItem = {},
  topRightItem = {},
  bottomLeftItem = {},
  bottomRightItem = {},
  bottomLeftImage = '',
}) {
  return (
    <div className={styles.wrapper}>
      <Grid container className={styles.gridWrapper} spacing={3}>
        {Object.keys(topLeftItem)?.length > 0 && (
          <Grid item xs={12} sm={6} md={6} id={topLeftItem.id}>
            <HelpCenterListWrapper {...topLeftItem} />
          </Grid>
        )}
        {Object.keys(topRightItem)?.length > 0 && (
          <Grid item xs={12} sm={6} md={6} id={topRightItem.id}>
            <HelpCenterListWrapper {...topRightItem} />
          </Grid>
        )}
        {Object.keys(bottomLeftItem)?.length > 0 && (
          <Grid item xs={12} sm={7} md={8} id={bottomLeftItem.id}>
            <div
              className={`${styles.border} ${
                bottomLeftImage && bottomLeftImage?.path && styles.imageWrapper
              }`}
            >
              {bottomLeftImage && bottomLeftImage?.path && (
                <img
                  src={bottomLeftImage.path}
                  alt={bottomLeftImage.alt}
                  loading="lazy"
                  className={styles.bottomLeftImage}
                  {...{
                    ...(bottomLeftImage.width && {
                      width: bottomLeftImage.width,
                    }),
                    ...(bottomLeftImage.height && {
                      height: bottomLeftImage.height,
                    }),
                  }}
                />
              )}
              <div className={styles.listItem}>
                <HelpCenterListItem {...bottomLeftItem} />
              </div>
            </div>
          </Grid>
        )}
        {Object.keys(bottomRightItem)?.length > 0 && (
          <Grid item xs={12} sm={5} md={4} id={bottomRightItem.id}>
            <div className={`${styles.border} ${styles.listItem}`}>
              <HelpCenterListItem {...bottomRightItem} />
            </div>
          </Grid>
        )}
      </Grid>
    </div>
  );
}

HelpCenterGrid.propTypes = {
  topLeftItem: PropTypes.object,
  topRightItem: PropTypes.object,
  bottomLeftItem: PropTypes.object,
  bottomRightItem: PropTypes.object,
  bottomLeftImage: PropTypes.shape({
    path: PropTypes.string,
    alt: PropTypes.string,
  }),
};
